






















































































































































































import {Component, PropSync, Vue} from 'vue-property-decorator';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import QuickHelp from '@/views/components/input/QuickHelp.vue';
import {UnitSystem} from '@/interfaces/units';
import {ImperialUnits, MetricUnits} from '@/lib/unitConversion/unitConversionFactors';
import ProbabilisticChart from '@/modules/lcca/views/components/ProbablisticChart.vue';
import {IAgencyCostLineItemImperial, MainlineOptions} from '@/modules/agencyCost/interfaces/agencyCost';
import {
  agencyLineItemImperialToMetric,
  agencyLineItemMetricToImperial,
} from '@/modules/agencyCost/lib/unitConversion/agencyScenario';
import {agencyStore} from '@/store/store';

@Component({
  components: {
    QuickHelp,
    PxTextEntryBox,
    PxTextArea,
    ProbabilisticChart,
    PxDropdown,
    PxNumberInput,
  },
})
export default class AgencyCostEditLineItemModalContent extends Vue {
  @PropSync('itemToEdit') itemToEditImperial!: IAgencyCostLineItemImperial;

  unitSystems = UnitSystem;

  smCols = 4;

  mdCols = 4;

  lgCols = 4;

  get currentUnitSystemIsImperial() {
    return this.itemToEditImperial.displayUnits === UnitSystem.Imperial;
  }

  changeUnitSytem() {
    this.itemToEditImperial.displayUnits = this.currentUnitSystemIsImperial ? UnitSystem.Metric : UnitSystem.Imperial;
  }

  get itemToEditMetric() {
    return agencyLineItemImperialToMetric(this.itemToEditImperial);
  }

  get showThickness() {
    if (this.itemToEditImperial.displayUnits === UnitSystem.Imperial) {
      switch (this.itemToEditImperial.units) {
        case ImperialUnits.LENGTH_IN:
          return true;
        default:
          return false;
      }
    } else if (this.itemToEditImperial.displayUnits === UnitSystem.Metric) {
      switch (this.itemToEditMetric.units) {
        case MetricUnits.LENGTH_CM:
          return true;
        default:
          return false;
      }
    }
    return false;
  }

  get showDensity() {
    if (this.itemToEditImperial.displayUnits === UnitSystem.Imperial) {
      console.log('imp');
      switch (this.itemToEditImperial.units) {
        case ImperialUnits.VOLUME_YD2IN:
          return true;
        case ImperialUnits.VOLUME_FT3:
          return true;
        case ImperialUnits.VOLUME_GAL:
          return true;
        case ImperialUnits.VOLUME_YD3:
          return true;
        case ImperialUnits.MASS_SHTN:
          return true;
        case ImperialUnits.MASS_LB:
          return true;
        default:
          return false;
      }
    } else if (this.itemToEditImperial.displayUnits === UnitSystem.Metric) {
      console.log('met');
      switch (this.itemToEditMetric.units) {
        case MetricUnits.VOLUME_M2CM:
          return true;
        case MetricUnits.VOLUME_CM3:
          return true;
        case MetricUnits.VOLUME_L:
          return true;
        case MetricUnits.VOLUME_M3:
          return true;
        case MetricUnits.MASS_MTON:
          return true;
        case MetricUnits.MASS_KG:
          return true;
        default:
          return false;
      }
    }
    return false;
  }

  get showQuantity() {
    if (this.itemToEditImperial.units === ImperialUnits.UNITS) {
      return true;
    }
    return false;
  }

  unitSystemIsImperial() {
    return this.itemToEditImperial.displayUnits === UnitSystem.Imperial;
  }

  get unitOptions() {
    if (this.unitSystemIsImperial()) {
      return Object.values(ImperialUnits).map((U) => ({ value: U, text: U }));
    }
    return Object.values(MetricUnits).map((U) => ({ value: U, text: U }));
  }

  get mainlineOptions() {
    return Object.values(MainlineOptions).map((v) => ({ text: v, value: v }));
  }

  saveCopy() {
    this.sync();
    const copy = JSON.parse(JSON.stringify(this.itemToEditImperial));
    copy.id = null;
    copy.isDefault = true;
    copy.activity = null;
    agencyStore.saveNewDefaultLineItem(copy).then(() => this.$emit('saved'));
  }

  save() {
    this.sync();
    agencyStore.saveLineItem(this.itemToEditImperial).then(() => {
      this.$emit('saved');
    });
  }

  sync() {
    this.$emit('sync');
    if (this.itemToEditImperial.displayUnits === UnitSystem.Metric) {
      this.itemToEditImperial = agencyLineItemMetricToImperial(this.itemToEditMetric);
      this.itemToEditImperial.displayUnits = UnitSystem.Metric;
    }
  }
}
